var _defs, _path, _rect, _rect2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.101,
    height: 242.554,
    viewBox: "0 0 180.101 242.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 180.101,
    height: 242.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 154.383,
    height: 12.47,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M152.359,199.015H22.971a12.5,12.5,0,0,1-12.5-12.5V55.3H164.856V186.517a12.5,12.5,0,0,1-12.5,12.5",
    transform: "translate(8.247 43.54)",
    fill: "#ff3d02"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 23.334,
    height: 143.716,
    transform: "translate(84.243 98.839)",
    fill: "#d5a457"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 154.382,
    height: 23.334,
    transform: "translate(18.719 153.696)",
    fill: "#d5a457"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(18.719 98.839)",
    opacity: 0.54,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 154.382,
    height: 12.47,
    transform: "translate(0.001 -0.001)",
    fill: "#11273a"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M59.909,65.585c-1.827.311-3.292.534-4.3.676l-9.5-12.924C51.841,41.279,72.269,1.82,94.98.063c5.673-.434,13.879,1.173,20.762,11.309,7.012,10.32,5.619,18.949,3.217,24.372-8.608,19.429-44.777,27.409-59.05,29.842M67.63,47.31c13.974-3.8,42.811-13.275,33.048-25.706C92.022,10.585,76.074,33.672,67.63,47.31",
    transform: "translate(-158.69 -7.001)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M11.125,52.023c-4.061-4.32-8.233-12-5.035-24.065C9.229,16.115,16.441,11.885,21.935,10.415,43.948,4.551,76.29,35.02,85.685,44.5L81,59.841c-.994.2-2.45.475-4.277.785-14.274,2.433-51.045,6.878-65.6-8.6m12.569-19.4c-5.1,14.962,25.25,14.352,39.7,13.312-12.483-10.074-35.177-26.576-39.7-13.312",
    transform: "translate(-191.098 0.615)",
    fill: "#d5a457"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M175.3,54.533,10.107,82.68a5.766,5.766,0,0,1-6.651-4.715L.083,58.162A5.763,5.763,0,0,1,4.8,51.513l165.2-28.147a5.765,5.765,0,0,1,6.651,4.713l3.373,19.8a5.762,5.762,0,0,1-4.713,6.651",
    transform: "translate(-195 11.331)",
    fill: "#ff3d02"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 23.333,
    height: 31.617,
    transform: "translate(-119.105 50.729) rotate(-9.671)",
    fill: "#d5a457"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.1bb629225ad16a2beef621f8ffabafa6.svg";
export { ForwardRef as ReactComponent };